import { useMutation, useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useEmails(iboNumber) {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, refetch } = useQuery(
    ["emails", iboNumber],
    () =>
      makeAuthedRequest(`/v1/membership/emails/${iboNumber}`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    { staleTime: 0 }
  );

  const emailArchivePut = useMutation((emailObj) =>
    makeAuthedRequest(`/v1/membership/emails`, {
      method: "PUT",
      body: JSON.stringify(emailObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  return {
    data,
    isLoading,
    refetch,
    emailArchivePut,
  };
}
